<div class="logate-chat-interaction-unread">
  <div class="logate-chat-interaction-unread--line"></div>
  <div class="logate-chat-interaction-unread--content">Nove poruke</div>
  <div class="logate-chat-interaction-unread--line"></div>
</div>
